import React from "react";
import * as R from "@radix-ui/react-radio-group";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Radio = _ref => {
  var {
    items,
    onChange,
    name,
    error
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(R.Root, {
      name: name,
      onValueChange: onChange,
      className: "radio-group",
      children: items.map((item, idx) => /*#__PURE__*/_jsxs("div", {
        className: "radio-container",
        children: [/*#__PURE__*/_jsx(R.Item, {
          value: item.value,
          id: item.value + "-" + name,
          className: "radio-item",
          children: /*#__PURE__*/_jsx(R.Indicator, {
            className: "radio-indicator"
          })
        }), /*#__PURE__*/_jsx("label", {
          className: "cursor-pointer select-none",
          htmlFor: item.value + "-" + name,
          children: item.label
        })]
      }, idx))
    }), error && /*#__PURE__*/_jsx("small", {
      className: "text-red-400 p-1",
      children: error
    })]
  });
};
export default Radio;
//# sourceMappingURL=radio.js.map